export default "__VITE_ASSET__DFLeA7qA__"